
import videojs from 'video.js/dist/video.min';
import '@videojs/http-streaming/dist/videojs-http-streaming.min';
var youbora = require('youboralib')
require('youbora-adapter-videojs')

export default {
  init() {


    if (jQuery('nav.navbar.affix').length) {
      jQuery(window).on('scroll', function () {
        let scrollValue = jQuery(window).scrollTop();
        if (scrollValue > 65) {
          jQuery('nav.navbar.affix').addClass('fixed-top');
        } else {
          jQuery('nav.navbar.affix').removeClass('fixed-top');
        }
      });
    }

    let navMain = $('.navbar-collapse');
    navMain.on('click', 'a:not([data-toggle])', null, function () {
      navMain.collapse('hide');
    });

    $('#speakers .speaker.secondary .image-wrap, #speakers .speaker.secondary .name').click(function () {
      $(this).siblings('.more').children('a').click();
    });

    $('.speakers-video.modal').on('hidden.bs.modal', function () {
      let id = $(this).attr('id');
      $('#' + id + ' iframe').attr('src', $('#' + id + ' iframe').attr('src'));
    });

    $('#speakers .more a').click(function (event) {
      event.preventDefault();

      if ($(this).hasClass('expanded')) {
        let feature = $(this).attr('data-id');
        $(this).removeClass('expanded').html('+');
        $('.' + feature).removeClass('expanded');
      } else {
        $('#speakers .mobile-details.expanded').removeClass('expanded');
        $('#speakers .desktop-details.expanded').removeClass('expanded');
        $('#speakers .more a.expanded').removeClass('expanded').html('+');

        let feature = $(this).attr('data-id');
        $(this).addClass('expanded').html('-');
        $('.' + feature).addClass('expanded');
      }
    });

    $('#features .feature .feature-image-wrap').click(function () {

      if ($(this).parents('.feature').hasClass('expanded')) {
        $(this).siblings('.feature-content').slideToggle();
        $(this).parents('.feature').removeClass('expanded');
      } else {
        $('#features .feature.expanded .feature-content').slideToggle();
        $('#features .feature.expanded').removeClass('expanded');
        $(this).siblings('.feature-content').slideToggle();
        $(this).parents('.feature').addClass('expanded');
      }
    });


    $('.scroll-to-link').on('click', function (event) {
      var hash = this.hash;

      if (hash !== '') {
        event.preventDefault();

        if (hash.substring(1, 8) === 'feature') {
          $('html, body').animate({
            scrollTop: $(hash).offset().top - 63,
          }, 800, function () {
            $(hash + ' .feature-image-wrap').click();
          });
        }

        if (hash.substring(1, 8) === 'ska') {
          $('html, body').animate({
            scrollTop: $('#feature-54').offset().top - 63,
          }, 1500, function () {
            $('#feature-54 .feature-content').slideDown();
            $(this).parents('#feature-54 .feature').addClass('expanded');
          });
        }
      }
    });

    $('.navbar a').on('click', function (event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== '') {

        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 63,
        }, 800, function () {

        });

      } // End if

    });

    $('body.template-watch .video-link').on('click', function (event) {
      event.preventDefault();

      let title = $(this).attr('data-title');
      let speaker = $(this).attr('data-speaker');
      let video_embed = $(this).attr('data-embed');

      $(this).closest('.video-section').find('.video-wrap').html(video_embed);
      $(this).closest('.video-section').find('.video-header .title').html(title);
      $(this).closest('.video-section').find('.video-header .speaker').html(speaker);

      $('html, body').animate({
        scrollTop: $(this).closest('.video-section').offset().top,
      }, 800, function () {
      });
    });

    if ($('#live-container.video-js').length) {
      let player = videojs('live-container');

      if (typeof youbora !== undefined) {
        window.plugin = new youbora.Plugin({
          'accountCode': 'kcmprod',
          'content.isLive': true,
          'content.isLive.noSeek': true,
          'content.title': 'Ministers Conference',
          'extraparam.1': 'KCM',
          'extraparam.2': 'mc2022.kcm.org',
        });

        // eslint-disable-next-line no-undef
        plugin.setAdapter(new youbora.adapters.Videojs(player));
      }

      player.src([
        {type: 'application/x-mpegURL', src: 'https://content-z.uplynk.com/channel/7ec4ed9f56294cb6805ab6d5d0a8fa58.m3u8'},
      ]);

      player.play();

    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js